'use client';

import { shouldDisplayInSpanish } from '@/utils/form-utils';
import { usePathname } from 'next/navigation';
import GoogleRecaptcha from 'react-google-recaptcha';
export enum RecaptchaStatus {
  NotCompleted = 1,
  WaitingForSession = 2,
  Completed = 3,
}

interface PaymentRecaptchaProps {
  handleRecaptchaChange: (token: string | null) => void;
  handleRecaptchaError: () => void;
  bgSessionId: string | null;
  shouldHighlight?: boolean;
}

// Component to conditionally render the recaptcha used for guarding
// the call to GetSecurityToken.
// We should show the recaptcha unless we already have a paySession
// and that paySession has a BG Session ID
export function PaymentRecaptcha(props: PaymentRecaptchaProps) {
  const {
    handleRecaptchaChange,
    handleRecaptchaError,
    bgSessionId,
    shouldHighlight = false,
  } = props;

  const pathname = usePathname();

  const showComponent = !bgSessionId;
  return (
    <>
      {showComponent && (
        <GoogleRecaptcha
          sitekey={`${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
          onChange={handleRecaptchaChange}
          onErrored={handleRecaptchaError}
          style={{
            border: `3px solid ${shouldHighlight ? 'red' : 'initial'}`,
            borderRadius: '.5rem',
          }}
          hl={shouldDisplayInSpanish(pathname) ? 'es' : undefined}
        />
      )}
    </>
  );
}
